import styled from 'styled-components';
import device from '#app/interface/devices';

export const HeaderWrapper = styled.div`
  background: #fff;
  height: 100px;
`;

export const HeaderContainer = styled.div`
  background: #fff;
  padding: 21px 0;
  position: absolute;
  left: 0;
  right: 0;
  top: 20px;
  line-height: 0;
  z-index: 20;

  &.scrolled {
    position: fixed;
    top: 0px;
  }
`;

export const Wrap = styled.div`
  max-width: 1440px;
  padding: 0 50px;
  margin: 0 auto;
  position: relative;
`;

export const ModalText = styled.div`
  margin-left: 20px;
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 16px;
  color: #000;
`;

export const HeaderLogo = styled.div`
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const HeaderLogoLink = styled.a`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  cursor: pointer;
  text-decoration: none;
  opacity: 0.85;
  transition: opacity 0.2s;
  color: #000000;
  min-height: 0;

  &:hover {
    opacity: 1;
  }

  svg {
    width: 147px;
    height: 22px;
    flex-shrink: 0;
  }

  svg path {
    fill: #000000;
  }
`;

export const HeaderLogoText = styled.span`
  font-size: 20px;
  line-height: 1.2;
  color: #000000;
  font-family: 'Montserrat', Arial, sans-serif;
  font-weight: 600;
`;

export const HeaderMenu = styled.div`
  position: absolute;
  left: 275px;
  top: 50%;
  transform: translate3d(0, -150%, 0);
  opacity: 0;
  transition: 0.3s all;

  .scrolled > & {
    transform: translate3d(0, -50%, 0);
    opacity: 1;
  }

  & > div > a {
    padding: 18px;
    font-size: 18px;
    line-height: 28px;
    display: inline-block;
    margin-right: 44px;
    position: relative;
    color: #202020;
    text-decoration: none;

    &:hover {
      color: rgba(32, 32, 32, 0.6);

      :before {
        background: #4378ff;
      }
    }

    :before {
      position: absolute;
      left: 18px;
      right: 18px;
      top: 0;
      height: 4px;
      background: 0 0;
      display: block;
      content: '';
      transition: 0.3s all;
    }
  }
`;

export const HeaderPersonal = styled.div`
  position: absolute;
  top: 50%;
  right: 300px;
  transform: translate3d(0, -50%, 0);

  a {
    color: #fff;
    background: #4378ff;
    display: inline-block;
    cursor: pointer;
    font-size: 18px;
    line-height: 32px;
    padding: 8px 18px;
    white-space: nowrap;
    height: 48px;
    border-radius: 10px;
    border: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    transition: 0.3s all;
    box-sizing: border-box;
  }

  @media ${device.mobileL} {
    right: 20px;
  }
`;

export const HeaderOther = styled.div`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translate3d(0, -50%, 0);

  & > a:hover .other-swan-link:after {
    left: 175px;
    transition: 0.3s all;
    filter: grayscale(0%) brightness(100%);
  }
`;
